import * as actions from './index'
import fetch from 'isomorphic-fetch'
import SocketIOClient from 'socket.io-client'
import { polyfill } from 'es6-promise'
import { renjuBoardCardToStr, getRootURL } from '../lib'
import { types } from '../constants/ActionTypes'
import * as constants from '../constants'
import { deepCopy } from '../lib'
import { tokenSilentlyOption } from '../lib/Auth0'

const BITLY_ACCESS_TOKEN = 'e03450bf0bf40b6f53a153cffb40c9b36a2449df';

polyfill()

export const fetchErrorMessagePost = (errorMessage) => (dispatch) => {
  dispatch(requestErrorMessagePost(errorMessage))
  
  return fetch(getRootURL(), {
    port: 80,
    headers: {
      "Content-Type": "application/json",
    },
    method: 'POST',
    path: "/error",
  })
  .then(response =>
    dispatch(receiveErrorMessagePost(errorMessage, response))
  )
}

export const requestErrorMessagePost = (errorMessage) => ({
  type: types.REQUEST_ERROR_MESSAGE_POST,
  errorMessage,
})

export const receiveErrorMessagePost = (errorMessage, response) => ({
  type: types.RECEIVE_ERROR_MESSAGE_POST,
  errorMessage,
  response,
})

export const googleMap = {
  completedLoad: () => ({
    type: types.googleMap.LOAD_COMPLETED
  })
}

export const media = {
  upload: (field, elementId, callback) => (dispatch, getState) => {

    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      var formData = new FormData();
      var fileInput = document.querySelector(elementId)
      formData.append(field, fileInput.files[0])
      dispatch(media.requestUpload(formData))
      return fetch(`${getRootURL()}/images/${field}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + accessToken
        },
        body: formData,
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(media.responseUpload((json)))
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  requestUpload: (request) => ({
    type: types.fetch.media.REQUEST_UPLOAD,
    request,
  }),
  responseUpload: (response) => ({
    type: types.fetch.media.RESPONSE_UPLOAD,
    response,
  }),
}

export const user = {
  add: (data, requestCallback, responseCallback) => (dispatch, getState) => {
    var body

    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = {
        ...data,
      }
      if (requestCallback !== undefined) {
        requestCallback(dispatch)
      }
      dispatch(board.requestAdd(body))
      return fetch(getRootURL() + '/user/add', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (responseCallback !== undefined) {
        responseCallback(dispatch, json)
      }
      dispatch(user.responseAdd(json, body))
    })
    .catch((error) => {
      console.dir(error)
    })    
  },
  update: (data, callback) => (dispatch, getState) => {
    var body
    
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { ...data }
      dispatch(user.requestUpdate(body))
      return fetch(getRootURL() + '/user/update', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then(response => response.json())
    .then(json => {
      dispatch(user.responseUpdate(json))
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  delete: () => (dispatch, getState) => {
    var body

    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      dispatch(user.requestDelete(body))
      return fetch(getRootURL() + '/user/delete', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(user.responseDelete(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  select: (search, callback) => (dispatch, getState) => {
    var body
    const { auth0 } = getState().authentication
    if (!auth0) return
    auth0.isAuthenticated()
    .then(result => {
      if (result) {
        return auth0.getTokenSilently(tokenSilentlyOption)
      }
      else {
        return Promise.resolve(undefined)
      }
    })
    .then(accessToken => {
      let headers = {
        "Content-Type": "application/json",
      }
      if (accessToken) {
        headers.Authorization = 'Bearer ' + accessToken
      }
      body = { ...search }
      dispatch(user.requestSelect(body))
      fetch(getRootURL() + '/user/select', {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      })
      .then(response => response.json())
      .then(json => {
        if (callback !== undefined) {
          callback(dispatch, json)
        }
        dispatch(user.responseSelect(json))
      })
      .catch((error) => {
        console.dir(error)
      })
    })
  },
  settings: (callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      dispatch(user.requestSettings(body))
      return fetch(getRootURL() + '/user/settings', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then(response => response.json())
    .then(json => {
      if (callback !== undefined) {
        callback(dispatch, json)
      }
      dispatch(user.responseSettings(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  requestAdd: (request) => ({
    type: types.fetch.user.REQUEST_ADD,
    request,
  }),
  responseAdd: (response) => ({
    type: types.fetch.user.RESPONSE_ADD,
    response,
  }),
  requestUpdate: (requst) => ({
    type: types.fetch.user.REQUEST_UPDATE,
    requst,
  }),
  responseUpdate: (response) => ({
    type: types.fetch.user.RESPONSE_UPDATE,
    response,
  }),
  requestDelete: (requst) => ({
    type: types.fetch.user.REQUEST_DELETE,
    requst,
  }),
  responseDelete: (response) => ({
    type: types.fetch.user.RESPONSE_DELETE,
    response,
  }),
  requestSelect: (requst) => ({
    type: types.fetch.user.REQUEST_SELECT,
    requst,
  }),
  responseSelect: (response) => ({
    type: types.fetch.user.RESPONSE_SELECT,
    response,
  }),
  requestCredential: (requst) => ({
    type: types.fetch.user.REQUEST_CREDENTIAL,
    requst,
  }),
  responseCredential: (response) => ({
    type: types.fetch.user.RESPONSE_CREDENTIAL,
    response,
  }),
  requestSettings: (requst) => ({
    type: types.fetch.user.REQUEST_SETTINGS,
    requst,
  }),
  responseSettings: (response) => ({
    type: types.fetch.user.RESPONSE_SETTINGS,
    response,
  }),
}

export const bitly = {
  fetchMakeShortURL: (url, twitterText) => (dispatch, getState) => {
    var webAPIURL = new URL("https://api-ssl.bitly.com/v4/shorten")
    dispatch(bitly.requestMakeShortURL(webAPIURL.search))
    return fetch(webAPIURL.toString(), {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${BITLY_ACCESS_TOKEN}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "domain": "bit.ly",
        "long_url": url
      })
    })
    .then(response => response.json())
    .then(json =>
      dispatch(bitly.receiveMakeShortURL(json, twitterText))
    )
  },
  requestMakeShortURL: (urlParam) => ({
    type: types.bitly.REQUEST_MAKE_SHORT_URL,
    urlParam: urlParam,
  }),
  receiveMakeShortURL: (response, twitterText) => ({
    type: types.bitly.RECEIVE_MAKE_SHORT_URL,
    response,
    twitterText,
  }),
  clearShortURL: () => ({
    type: types.bitly.CLEAR_SHORT_URL,
  })
}

export const twitter = {
  fetchTweet: (data) => (dispatch, getState) => {
    const { text, datetime, image, url, checkedSchedule, checkedImage } = data
    var schedule, now, body
    schedule = new Date( datetime )
    now = new Date()
    if (checkedSchedule && schedule.getTime() < now.getTime()){
      dispatch(actions.snackbar.notify('過去の時間は設定できません。', 'error'))
      return
    }
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = {
        text,
        image: checkedImage ? image.split(',')[1] : undefined,
        datetime: checkedSchedule ? schedule.getTime() : undefined,
        url,
      }
      if (checkedSchedule) {
        dispatch(twitter.requestTweet())
        return fetch(getRootURL() + '/sns/twitter/schedule_tweet', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            Authorization: 'Bearer ' + accessToken
          },
          body: JSON.stringify(body),
        })
        .then((response) => response.json())
        .then((json) => {
          dispatch(twitter.receiveTweet(json))
          if (json.result) {
            dispatch(actions.snackbar.notify('ツイートを予約しました。', 'success'))
          }
          else {
            dispatch(actions.snackbar.notify('ツイートの予約に失敗しました。', 'error'))
          }
        })
        .catch((error) => {
          console.log(error)
          dispatch(actions.snackbar.notify('ツイートの予約に失敗しました。', 'error'))
        })
      }
      else {
        dispatch(twitter.requestTweet())
        return fetch(getRootURL() + '/sns/twitter/tweet', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            Authorization: 'Bearer ' + accessToken
          },
          body: JSON.stringify(body),
        })
        .then((response) => response.json())
        .then((json) => {
          dispatch(twitter.receiveTweet(json))
          if (json.result) {
            dispatch(actions.snackbar.notify('ツイートが完了しました。', 'success'))
          }
          else {
            dispatch(actions.snackbar.notify('ツイートに失敗しました。', 'error'))
          }
        })
        .catch((error) => {
          console.log(error)
          dispatch(actions.snackbar.notify('ツイートに失敗しました。', 'error'))
        })
      }
    })
    .catch((error) => {
      console.log(error)
      dispatch(actions.snackbar.notify('ツイートに失敗しました。', 'error'))
    })
  },
  requestTweet: () => ({
    type: types.twitter.REQUEST_TWEET,
  }),
  receiveTweet: (response) => ({
    type: types.twitter.RECEIVE_TWEET,
    response,
  }),

  fetchGetScheduleTweetList: () => (dispatch, getState) => {
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      var params = []
      dispatch(twitter.requestGetScheduleTweetList())
      return fetch(getRootURL() + '/sns/twitter/get_schedule_tweet', {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: 'Bearer ' + accessToken
        },
        body: params.join('&'),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(twitter.receiveGetScheduleTweetList(json))
      if (!json.result){
        dispatch(actions.snackbar.notify('予約ツイート一覧の取得に失敗しました。', 'error'))
      }
    })
  },
  requestGetScheduleTweetList: () => ({
    type: types.twitter.REQUEST_GET_SCHEDULE_TWEET_LIST,
  }),
  receiveGetScheduleTweetList: (response) => ({
    type: types.twitter.RECEIVE_GET_SCHEDULE_TWEET_LIST,
    response,
  }),
  clearScheduleTweetList: () => ({
    type: types.twitter.CLEAR_SCHEDULE_TWEET_LIST,
  }),

  fetchDeleteScheduleTweet: (deleteId) => (dispatch, getState) => {
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      var params = []
      params.push('sid=' + deleteId);
      dispatch(twitter.requestDeleteScheduleTweet())
      fetch(getRootURL() + "/sns/twitter/delete_schedule_tweet", {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: 'Bearer ' + accessToken
        },
        body: params.join('&'),
      })
      .then((response) => response.json())
      .then((json) => {
        dispatch(twitter.receiveDeleteScheduleTweet(json, deleteId))
        if (json.result){
          dispatch(actions.snackbar.notify('予約投稿を削除しました。', 'success'))
        }
        else {
          dispatch(actions.snackbar.notify('予約ツイートの削除に失敗しました。', 'error'))
        }
      })
    });
  },
  requestDeleteScheduleTweet: () => ({
    type: types.twitter.REQUEST_DELETE_SCHEDULE_TWEET,
  }),
  receiveDeleteScheduleTweet: (response, deleteId) => ({
    type: types.twitter.RECEIVE_DELETE_SCHEDULE_TWEET,
    response,
    deleteId,
  }),
}

export const event = {
  add: (data) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    return auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { ...data }
      return fetch(getRootURL() + '/event/add', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
  },
  update: (id, data) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    return auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = {
        id,
        ...data,
      }
      return fetch(getRootURL() + '/event/update', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
  },
  delete: (id, callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = {
        id,
      }
      return fetch(getRootURL() + '/event/delete', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  selectAttend: (id, callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id }
      return fetch(getRootURL() + '/event/select_attend', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then(response => response.json())
    .then(json => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  selectInterest: (id, callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id }
      return fetch(getRootURL() + '/event/select_interest', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  select: (param, callback) => (dispatch, getState) => {
    var body, headers
    const auth0 = getState().authentication.auth0
    const user = getState().authentication.user
    new Promise((resolve, reject) => {
      if (!auth0 || !user) {
        return resolve(undefined)
      }
      else {
        return auth0.getTokenSilently(tokenSilentlyOption).then(accessToken => resolve(accessToken))
      }
    })
    .then(accessToken => {
      body = { ...param }
      headers = {
        "Content-Type": "application/json",
      }
      if (accessToken) {
        headers.Authorization = 'Bearer ' + accessToken
      }
      return fetch(getRootURL() + '/event/select', {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      })
    })
    .then(response => response.json())
    .then(json => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  selectHistory: (id, callback) => (dispatch, getState) => {
    var body
    body = { id }
    fetch(getRootURL() + '/event/select_history', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
}

export const board = {
  add: (card, title) => (dispatch, getState) => {
    var boardContext, body
    boardContext = renjuBoardCardToStr(card)
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { title, boardContext }
      dispatch(board.requestAdd(body))
      return fetch(getRootURL() + '/board/add', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (json.result === true) {
        dispatch(actions.snackbar.notify('保存しました。'))
      }
      else {
        dispatch(actions.snackbar.notify('保存に失敗しました。', 'error'))
      }
      dispatch(board.responseAdd(json, body))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  update: (id, card, title) => (dispatch, getState) => {
    var boardContext, body
    if (card !== undefined) {
      boardContext = renjuBoardCardToStr(card)
    }
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = {
        id,
        title,
        boardContext,
      }
      dispatch(board.requestUpdate(body))
      return fetch(getRootURL() + '/board/update', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (json.result) {
        if (card === undefined && title !== undefined) {
          dispatch(actions.snackbar.notify('ファイル名を変更しました。'))  
        }
        else {
          dispatch(actions.snackbar.notify('保存しました。'))
        }
      }
      else {
        if (card === undefined && title !== undefined) {
          dispatch(actions.snackbar.notify('ファイル名の変更に失敗しました。', 'error'))
        }
        else {
          dispatch(actions.snackbar.notify('保存に失敗しました。', 'error'))
        }
      }
      dispatch(board.responseUpdate(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  delete: (id) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {  
      body = { id }
      dispatch(board.requestDelete(body))
      return fetch(getRootURL() + '/board/delete', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (json.result) {
        dispatch(actions.snackbar.notify('削除しました。'))
      }
      else {
        dispatch(actions.snackbar.notify('削除に失敗しました。', 'error'))
      }
      dispatch(board.responseDelete(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  select: () => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      dispatch(board.requestSelect(body))
      return fetch(getRootURL() + '/board/select', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(board.responseSelect(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  requestAdd: (request) => ({
    type: types.fetch.board.REQUEST_ADD,
    request,
  }),
  responseAdd: (response) => ({
    type: types.fetch.board.RESPONSE_ADD,
    response,
  }),
  requestUpdate: (requst) => ({
    type: types.fetch.board.REQUEST_UPDATE,
    requst,
  }),
  responseUpdate: (response) => ({
    type: types.fetch.board.RESPONSE_UPDATE,
    response,
  }),
  requestDelete: (requst) => ({
    type: types.fetch.board.REQUEST_DELETE,
    requst,
  }),
  responseDelete: (response) => ({
    type: types.fetch.board.RESPONSE_DELETE,
    response,
  }),
  requestSelect: (requst) => ({
    type: types.fetch.board.REQUEST_SELECT,
    requst,
  }),
  responseSelect: (response) => ({
    type: types.fetch.board.RESPONSE_SELECT,
    response,
  }),
}

export const puzzle = {
  add: (data) => (dispatch, getState) => {
    var newData, boardContext, body
    newData = deepCopy(data)
    boardContext = renjuBoardCardToStr(newData.card)
    if (!newData.checkDateTime) {
      delete newData.datetime
    }
    delete newData.checkDateTime
    delete newData.card
    delete newData.bid
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { boardContext, ...newData }
      dispatch(puzzle.requestAdd())
      return fetch(getRootURL() + '/puzzle/add', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseAdd(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },

  update: (data) => (dispatch, getState) => {
    var newData, boardContext, body
    newData = deepCopy(data)
    boardContext = renjuBoardCardToStr(newData.card)
    if (!newData.checkDateTime) {
      delete newData.datetime
    }
    delete newData.checkDateTime
    delete newData.card
    delete newData.bid
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { boardContext, ...newData }
      dispatch(puzzle.requestUpdate(body))
      return fetch(getRootURL() + '/puzzle/update', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseUpdate(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  delete: (id) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id }
      dispatch(puzzle.requestDelete(body))
      return fetch(getRootURL() + '/puzzle/delete', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseDelete(json))
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  select: (param, callback) => (dispatch, getState) => {
    var headers, promise
    const auth0 = getState().authentication.auth0

    if (!auth0) {
      promise = new Promise((resolve, reject) => {
        return resolve(undefined)
      })
    }
    else {
      promise = auth0.getUser()
      .then(user => {
        if (user) {
          return auth0.getTokenSilently(tokenSilentlyOption)
        }
        else {
          return Promise.resolve(undefined)
        }
      })
    }
    promise
    .then(accessToken => {
      headers = { "Content-Type": "application/json" }
      if (accessToken) {
        headers.Authorization = 'Bearer ' + accessToken
      }
      dispatch(puzzle.requestSelect({...param}))
      return fetch(getRootURL() + '/puzzle/select', {
        method: 'POST',
        headers,
        body: JSON.stringify({ ...param }),
      })
    })
    .then(response => response.json())
    .then(json => {
      if (callback) {
        callback(json)
      }
      dispatch(puzzle.responseSelect(json))
    })
    .catch((error) => {
      console.log(error)
    })
  },
  selectedGood: (id) => (dispatch, getState) => {
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {  
      dispatch(puzzle.requestSelectedGood())
      return fetch(getRootURL() + '/puzzle/selected_good', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify({ id }),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseSelectedGood(json))
    })
  },
  selectedBad: (id) => (dispatch, getState) => {
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      dispatch(puzzle.requestSelectedBad())
      return fetch(getRootURL() + '/puzzle/selected_bad', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify({ id }),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseSelectedBad(json))
    })
  },
  addComment: (id, comment, isAppendedBoard, bid) => (dispatch, getState) => {
    var body, state
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id, comment }
      if (isAppendedBoard === true) {
        state = getState()
        body.boardContext = renjuBoardCardToStr(state.renjuBoardCards.cards[bid])
      }
      dispatch(puzzle.requestAddComment(body))
      return fetch(getRootURL() + '/puzzle/add_comment', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseAddComment(json))
    })
  },
  deleteComment: (id, commentId) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id, commentId }
      dispatch(puzzle.requestDeleteComment(body))
      return fetch(getRootURL() + '/puzzle/delete_comment', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      dispatch(puzzle.responseDeleteComment(json))
    })
  },
  requestAdd: () => ({
    type: types.fetch.puzzle.REQUEST_ADD,
  }),
  responseAdd: (response) => ({
    type: types.fetch.puzzle.RESPONSE_ADD,
    response,
  }),
  requestUpdate: (request) => ({
    type: types.fetch.puzzle.REQUEST_UPDATE,
    request,
  }),
  responseUpdate: (response) => ({
    type: types.fetch.puzzle.RESPONSE_UPDATE,
    response,
  }),
  requestDelete: (request) => ({
    type: types.fetch.puzzle.REQUEST_DELETE,
    request,
  }),
  responseDelete: (response) => ({
    type: types.fetch.puzzle.RESPONSE_DELETE,
    response,
  }),
  requestSelect: (request) => ({
    type: types.fetch.puzzle.REQUEST_SELECT,
    request,
  }),
  responseSelect: (response) => ({
    type: types.fetch.puzzle.RESPONSE_SELECT,
    response,
  }),
  requestSelectedGood: () => ({
    type: types.fetch.puzzle.REQUEST_SELECTED_GOOD,
  }),
  responseSelectedGood: (response) => ({
    type: types.fetch.puzzle.RESPONSE_SELECTED_GOOD,
    response,
  }),
  requestSelectedBad: () => ({
    type: types.fetch.puzzle.REQUEST_SELECTED_BAD,
  }),
  responseSelectedBad: (response) => ({
    type: types.fetch.puzzle.RESPONSE_SELECTED_BAD,
    response,
  }),
  requestAddComment: (request) => ({
    type: types.fetch.puzzle.REQUEST_ADD_COMMENT,
    request,
  }),
  responseAddComment: (response) => ({
    type: types.fetch.puzzle.RESPONSE_ADD_COMMENT,
    response,
  }),
  requestDeleteComment: (request) => ({
    type: types.fetch.puzzle.REQUEST_DELETE_COMMENT,
    request,
  }),
  responseDeleteComment: (response) => ({
    type: types.fetch.puzzle.RESPONSE_DELETE_COMMENT,
    response,
  }),
}

export const comment = {
  add: (id, comment, callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id, comment }
      return fetch(getRootURL() + '/comment/add', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  delete: (id, index, callback) => (dispatch, getState) => {
    var body
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.getTokenSilently(tokenSilentlyOption)
    .then(accessToken => {
      body = { id, index }
      return fetch(getRootURL() + '/comment/delete', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        body: JSON.stringify(body),
      })
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
  select: (id, callback) => (dispatch, getState) => {
    var body
    body = { id }
    fetch(getRootURL() + '/comment/select', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((json) => {
      if (callback) {
        callback(json)
      }
    })
    .catch((error) => {
      console.dir(error)
    })
  },
}
/*
const validateProps = {
  [constants.gameType.LIVE_GAME]: [
    { name: 'groupName',      type: validateType.STRINGS, must: true  },
    { name: 'gameType',       type: validateType.STRINGS, must: true  },
    { name: 'openingRule',    type: validateType.STRINGS, must: true  },
    { name: 'title',          type: validateType.STRINGS, must: true, maxStringLength: 20, minStringLength: 0 },
    { name: 'minute',         type: validateType.INTEGER, must: true, maxValue: 60, minValue: 1 },
    { name: 'increaseSecond', type: validateType.INTEGER, must: true, maxValue: 60, minValue: 0 },
    { name: 'enableUndo',     type: validateType.BOOLEAN, must: true },
    { name: 'turnType',       type: validateType.STRINGS, must: true },
  ],
  [constants.gameType.DAILY_GAME]: [
    { name: 'groupName',      type: validateType.STRINGS, must: true },
    { name: 'gameType',       type: validateType.STRINGS, must: true },
    { name: 'openingRule',    type: validateType.STRINGS, must: true },
    { name: 'title',          type: validateType.STRINGS, must: true, maxStringLength: 20, minStringLength: 0 },
    { name: 'days',           type: validateType.INTEGER, must: true, maxValue: 90, minValue: 1 },
    { name: 'daysPerMove',    type: validateType.INTEGER, must: true, maxValue: 60, minValue: 1 },
  ],
}
*/
/*
class Game {
  init = () => (dispatch, getState) => {
    const gameContext = useContext(GameContext)
    var state, socket
    state = getState()
    if (gameContext.socket) {
      return
    }
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.isAuthenticated()
    .then(result => {
      if (result) {
        return auth0.getTokenSilently(tokenSilentlyOption)
      }
      else {
        return Promise.resolve(undefined)
      }
    })
    .then(accessToken => {
      if (accessToken) {
        socket = SocketIOClient.connect(`${getRootURL()}/game`, {
          query: `token=${accessToken}`
        })
      }
      else {
        socket = SocketIOClient.connect(`${getRootURL()}/game`)
      }
      socket.on('connect', data => {
        if (accessToken) {
          socket.emit('authenticate', { token: accessToken })
          .on('authenticated', () => {
            gameContext.connect(socket)
          })
          .on('unauthorized', msg => {
          })
        }
        else {
          gameContext.connect(socket)
          socket.emit('authenticated')
        }
        console.dir('connect')
      })
      socket.on('disconnect', data => {
        console.dir(`disconnect ${data}`)
      })
      socket.on('server time', data => {
        gameContext.receiveServerTime(data)
      })
      socket.on('groups', data => {
        state = getState()
        if (gameContext.selectedGroup === undefined && data.groups.length > 0) {
          gameContext.joinGroup(data.groups[0].name)
        }
        gameContext.receiveGroups(data)
      })
      socket.on('create game room', data => {
        if (data.roomName !== '') {
          dispatch(routerActions.push(`/game/${data.groupName}/${data.roomName}`))
        }
      })
      socket.on('game rooms', data => {
        gameContext.receiveGameRooms(data)
      })
      socket.on('game room', data => {
        gameContext.receiveGameRoom(data)
      })
      socket.on('chat message', data => {
        var state, foundCard, card, url, winner, moves
        if (data.type === constants.CHAT_TYPE.GAME_RESULT) {
          state = getState()
          foundCard = state.renjuBoardCards.cards.find(card => card.groupName === data.groupName && card.roomName === data.roomName)
          if (!foundCard) {
            gameContext.receiveChatMessage(data)
            return
          }
          card = deepCopy(foundCard)
          card.settings.isVisibleGameInfo = true
          card.settings.isVisibleTitle = true
          card.settings.isVisiblePlayerName = true
          card.settings.isVisibleGameResult = true
          card.gameInfo.blackPlayerName =
            data.gameResult.player1.color === constants.stoneType.BLACK ? data.gameResult.player1.displayName :
            data.gameResult.player2.color === constants.stoneType.BLACK ? data.gameResult.player2.displayName : ''
          card.gameInfo.whitePlayerName =
            data.gameResult.player1.color === constants.stoneType.WHITE ? data.gameResult.player1.displayName :
            data.gameResult.player2.color === constants.stoneType.WHITE ? data.gameResult.player2.displayName : ''
          moves = card.moves.filter(move => move.number > 0)
          card.gameInfo.gameEndNumber = moves.length === 0 ? '' : `${moves[moves.length - 1].color}-${moves[moves.length - 1].number}`
          switch (data.gameResult.action) {
            case constants.ENDED_ACTION.FIVE:
              winner =
                data.gameResult.user.userName === data.gameResult.player1.userName ? data.gameResult.player1 :
                data.gameResult.user.userName === data.gameResult.player2.userName ? data.gameResult.player2 : undefined
              card.gameInfo.gameResult =
                winner && winner.color === constants.stoneType.BLACK ? 'BlackWin' :
                winner && winner.color === constants.stoneType.WHITE ? 'WhiteWin' : ''
              break
            case constants.ENDED_ACTION.RESIGN:
            case constants.ENDED_ACTION.TIMEOUT:
              winner =
                data.gameResult.user.userName === data.gameResult.player1.userName ? data.gameResult.player2 :
                data.gameResult.user.userName === data.gameResult.player2.userName ? data.gameResult.player1 : undefined
              card.gameInfo.gameResult =
                winner && winner.color === constants.stoneType.BLACK ? 'BlackWin' :
                winner && winner.color === constants.stoneType.WHITE ? 'WhiteWin' : ''
              break
            case constants.ENDED_ACTION.OFFER_DRAW:
              card.gameInfo.gameResult = 'Draw'
              break
            default:
              break
          }
          url = createURL(card, state.user.language)
          gameContext.receiveChatMessage({ ...data, url })
          return
        }
        gameContext.receiveChatMessage(data)
      })
    })
  }

  connect = (socket) => ({
    type: types.game.CONNECT,
    socket,
  })

  serverTime = () => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('server time')
  }

  groups = () => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('groups')
  }

  joinGroup = (groupName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('join group', { groupName })
  }

  leaveGroup = (groupName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('leave group', { groupName })
  }

  joinRoom = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('join room', { groupName, roomName })
  }

  leaveRoom = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('leave room', { groupName, roomName })
  }

  joinGame = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('join game', { groupName, roomName })
  }

  leaveGame = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('leave game', { groupName, roomName })
  }

  restartGame = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('restart game', { groupName, roomName })
  }

  newGame = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('new game', { groupName, roomName })
  }

  gameSettings = (settings) => (dispatch, getState) => {
    var socket, data
    const { gameType } = settings
    if (false === validate(settings, validateProps[gameType])){
      console.dir('error')
      return
    }
    data = {}
    validateProps[gameType].forEach(prop => data[prop.name] = settings[prop.name])
    data.roomName = settings.roomName
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('game settings', data)
  }

  resetGameSettings = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('reset game settings', { groupName, roomName })
  }

  ready = (groupName, roomName, ready) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('ready', { groupName, roomName, ready })
  }

  createGameRoom = (settings) => (dispatch, getState) => {
    var socket, data
    const { gameType } = settings
    if (false === validate(settings, validateProps[gameType])){
      return
    }
    data = {}
    validateProps[gameType].forEach(prop => data[prop.name] = settings[prop.name])
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('create game room', data)
  }

  move = (groupName, roomName, moves) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('move', { groupName, roomName, moves })
  }

  resign = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('resign', { groupName, roomName })
  }

  offerDraw = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('offer draw', { groupName, roomName })
  }

  acceptDraw = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('accept draw', { groupName, roomName })
  }

  denyDraw = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('deny draw', { groupName, roomName })
  }

  offerUndo = (numberOfUndo, groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('offer undo', { numberOfUndo, groupName, roomName })
  }

  acceptUndo = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('accept undo', { groupName, roomName })
  }

  denyUndo = (groupName, roomName) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('deny undo', { groupName, roomName })
  }

  chatMessage = (groupName, roomName, message) => (dispatch, getState) => {
    var socket
    const gameContext = useContext(GameContext)
    socket = gameContext.socket
    if (!socket) {
      return
    }
    socket.emit('chat message', { groupName, roomName, message })
  }

  receiveServerTime = (data) => ({
    type: types.game.RECEIVE_SERVER_TIME,
    data,
  })

  receiveGroups = (data) => ({
    type: types.game.RECEIVE_GROUPS,
    data,
  })
  
  receiveGameRooms = (data) => ({
    type: types.game.RECEIVE_GAME_ROOMS,
    data,
  })

  receiveGameRoom = (data) => ({
    type: types.game.RECEIVE_GAME_ROOM,
    data,
  })

  receiveChatMessage = (data) => ({
    type: types.game.RECEIVE_CHAT_MESSAGE,
    data,
  })
}

export const game = new Game()
*/

class Live {
  init = () => (dispatch, getState) => {
    var state, socket, liveIds, index, card
    state = getState()
    if (state.api.socket) {
      return
    }
    const auth0 = getState().authentication.auth0
    if (!auth0) return
    auth0.isAuthenticated()
    .then(result => {
      if (result) {
        return auth0.getTokenSilently(tokenSilentlyOption)
      }
      else {
        return Promise.resolve(undefined)
      }
    })
    .then(accessToken => {
      if (accessToken) {
        socket = SocketIOClient.connect(`${getRootURL()}/live`, {
          query: `token=${accessToken}`
        })
      }
      else {
        socket = SocketIOClient.connect(`${getRootURL()}/live`)
      }
      socket.on('connect', (data) => {
        if (accessToken) {
          socket.emit('authenticate', { token: accessToken })
          .on('authenticated', () => {
            dispatch(this.connect(socket))
          })
          .on('unauthorized', msg => {
          })
        }
        else {
          dispatch(this.connect(socket))
          socket.emit('authenticated')
        }
        state = getState()
        liveIds = state.api.live.liveIds
        if (liveIds.length > 0){
          for( index in liveIds ) {
            dispatch(this.joinLiveRoom(liveIds[index]))
          }
        }
      })
      socket.on('disconnect', (data) => {
        console.dir(data)
      })
      socket.on('live id', (data) => {
        dispatch(this.receiveLiveId(data.liveId))
      })
      socket.on('latest board context', (data) => {
        dispatch(this.receiveLatestBoardContext(data))
      })
      socket.on('update board context', (data) => {
        state = getState()
        card = state.renjuBoardCards.cards.filter((card) => { return card.live && card.live.liveId === data.liveId})
        if (card[0] && card[0].operationMode === constants.operationModeType.EDIT) {
          dispatch(actions.snackbar.notify('最新局面を受信しました。', 'info'))
        }
        else {
          dispatch(actions.snackbar.notify('最新局面を受信しました。', 'info'))
        }
        dispatch(this.receiveUpdateBoardContext(data))
      })
      socket.on('select board context', (data) => {
        dispatch(this.receiveSelectBoardContext(data))
      })
      socket.on('user type', (data) => {
        dispatch(this.receiveUserType(data))
      })
      socket.on('add chat message', (data) => {
        dispatch(this.receiveAddChatMessage(data))
      })
      socket.on('all chat message', (data) => {
        dispatch(this.receiveAllChatMessage(data))
      })
      socket.on('live status', (data) => {
        dispatch(this.receiveLiveStatus(data))
      })
      socket.on('joining users in room', (data) => {
        dispatch(this.receiveJoiningUsersInRoom(data))
      })
    })
  }

  connect = (socket) => ({
    type: types.live.CONNECT,
    socket,
  })

  joinLiveRoom = (liveId) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('join live room', { liveId })
  }

  leaveLiveRoom = (liveId) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('leave live room', {liveId})
  }

  startLiveGame = (openingRule, title, blackPlayerName, whitePlayerName) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('start live game', { openingRule, title, blackPlayerName, whitePlayerName })
  }

  restartLiveGame = (liveId) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('restart live game', { liveId })
  }

  endLiveGame = (liveId) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('end live game', { liveId })
  }

  deleteLiveGame = (liveId) => (dispatch, getState) => {
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('delete live game', { liveId })
  }

  updateBoardContext = (liveId) => (dispatch, getState) => {
    var state, socket, card, boardContext
    state = getState()
    card = state.renjuBoardCards.cards.filter((card) => {return card.live && card.live.liveId === liveId})
    if (!card.length){
      return
    }
    boardContext = renjuBoardCardToStr(card[0])
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('update board context', { liveId, boardContext })
  }

  selectBoardContext = (limit, offset, search) => (dispatch, getState) => {
    dispatch(this.requestSelectBoardContext())
    var state, socket
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    socket.emit('select board context', { limit, offset, search })
  }

  sendMessage = (liveId) => (dispatch, getState) => {
    var state, socket, message
    state = getState()
    socket = state.api.live.socket
    if (!socket) {
      return
    }
    message = state.chatCard.message
    socket.emit('add chat message', { liveId, message })
  }

  sendBoardMessage = (liveId, bid) => (dispatch, getState) => {
    var state, socket, boardContext
    state = getState()
    socket = state.api.live.socket
    if (!socket || !state.renjuBoardCards.cards[bid]) {
      return
    }
    boardContext = renjuBoardCardToStr(state.renjuBoardCards.cards[bid])
    socket.emit('add chat message', { liveId, message: '', boardContext })
  }

  receiveLiveId = (liveId) => ({
    type: types.live.RECEIVE_LIVE_ID,
    liveId,
  })

  receiveLatestBoardContext = (data) => ({
    type: types.live.RECEIVE_LATEST_BOARD_CONTEXT,
    result: data.result,
    liveId: data.liveId,
    contributor: data.contributor,
    startTime: data.startTime,
    boardContext: data.boardContext,
  })

  receiveUpdateBoardContext = (data) => ({
    type: types.live.RECEIVE_UPDATE_BOARD_CONTEXT,
    result: data.result,
    liveId: data.liveId,
    boardContext: data.boardContext,
  })

  requestSelectBoardContext = () => ({
    type: types.live.REQUEST_SELECT_BOARD_CONTEXT,
  })

  receiveSelectBoardContext = (data) => ({
    type: types.live.RECEIVE_SELECT_BOARD_CONTEXT,
    status: data.status,
    total: data.total,
    limit: data.limit,
    offset: data.offset,
    search: data.search,
    boardContexts: data.boardContexts,
  })

  receiveUserType = (data) => ({
    type: types.live.RECEIVE_USER_TYPE,
    liveId: data.liveId,
    userType: data.userType,
  })

  receiveAddChatMessage = (data) => ({
    type: types.live.RECEIVE_ADD_CHAT_MESSAGE,
    liveId: data.liveId,
    mid: data.mid,
    displayName: data.displayName,
    photoURL: data.photoURL,
    message: data.message,
    boardContext: data.boardContext,
    timestamp: data.timestamp,
  })

  receiveAllChatMessage = (data) => ({
    type: types.live.RECEIVE_ALL_CHAT_MESSAGE,
    liveId: data.liveId,
    allMessage: data.allMessage,
  })

  receiveLiveStatus = (data) => ({
    type: types.live.RECEIVE_LIVE_STATUS,
    liveId: data.liveId,
    status: data.status,
  })

  receiveJoiningUsersInRoom = (data) => ({
    type: types.live.RECEIVE_JOINING_USERS_IN_ROOM,
    liveId: data.liveId,
    users: data.users,
  })
}

export const live = new Live()



// WEBPACK FOOTER //
// ./src/actions/api.js